var _path, _path2, _path3, _g, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.14 5.707.432.668h7.553a.75.75 0 0 1 .75.75v8.25a.75.75 0 0 1-.75.75h-12a.75.75 0 0 1-.75-.75v-10.5a.75.75 0 0 1 .75-.75h3L8.14 5.707z",
    fill: "#111216",
    stroke: "#fff",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 4.5A2.624 2.624 0 0 1 22.5 7.125v11.25A2.624 2.624 0 0 1 19.875 21H4.125A2.624 2.624 0 0 1 1.5 18.375v-13.5A2.624 2.624 0 0 1 4.125 2.25h3.95l1.5 2.25h10.3z",
    fill: "#615AE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 3A1.874 1.874 0 0 0 2.25 4.875v13.5c0 1.036.839 1.875 1.875 1.875h15.75a1.874 1.874 0 0 0 1.875-1.875V7.125a1.874 1.874 0 0 0-1.875-1.875h-10.7L7.674 3h-3.55z",
    fill: "#615AE2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#goclvkihna)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.324v1.426h8.25v-1.426c0-1.454-1.852-2.637-4.125-2.637-2.273 0-4.125 1.183-4.125 2.637zM11.625 13.875c1.367 0 2.475-1.091 2.475-2.438C14.1 10.091 12.992 9 11.625 9S9.15 10.091 9.15 11.438c0 1.346 1.108 2.437 2.475 2.437z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 3A1.874 1.874 0 0 0 2.25 4.875s.003-1.713 0 2.6c0 0 19.5.022 19.5 0v-.35a1.874 1.874 0 0 0-1.875-1.875h-10.7L7.674 3h-3.55z",
    fill: "#DBD3ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#615AE2",
    d: "M2.25 7.125h19.5v.75H2.25z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "goclvkihna"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.5 9)",
    d: "M0 0h8.25v9.75H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFolder);
export default __webpack_public_path__ + "static/media/active-folder.f04cf6cea802630aac5a4d84a317743e.svg";
export { ForwardRef as ReactComponent };